import WritingCoach from "../features/WritingCoach/WritingCoach";

export default function WritingCoachPage() {
  return <WritingCoach />;
}
